import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    width: 'calc(100%)',
    height: '49px',
    backgroundColor: '#FFFFFF',
    zIndex: 20,
    paddingLeft: '5px',
  },
  containerNonFullscreen: {
    width: 'calc(99%)',
    marginTop: '10px',
  },
  containerNonSidebar: {
    top: '33px',
    left: '40px',
    width: 'calc(100% - 60px)',
  },
  containerFullscreen: {
    top: '-1px',
    left: '0px',
    width: '100vw',
  },
}));
